;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();const pendingScriptLoads = new Map<string, Promise<void>>()

type LoadScriptOptions = {
  id: string
  src: string
}

export function loadExternalScript({ id, src }: LoadScriptOptions): Promise<void> {
  if (typeof document === 'undefined') {
    return Promise.resolve()
  }

  const key = `${id}:${src}`
  const inFlight = pendingScriptLoads.get(key)
  if (inFlight) {
    return inFlight
  }

  const promise = new Promise<void>((resolve, reject) => {
    const existingScript = document.getElementById(id) as HTMLScriptElement | null
    const finalize = () => {
      pendingScriptLoads.delete(key)
      resolve()
    }
    const fail = () => {
      pendingScriptLoads.delete(key)
      reject(new Error(`Failed to load script: ${src}`))
    }

    if (existingScript) {
      if (existingScript.dataset.loaded === 'true') {
        finalize()
        return
      }

      existingScript.addEventListener(
        'load',
        () => {
          existingScript.dataset.loaded = 'true'
          finalize()
        },
        { once: true },
      )
      existingScript.addEventListener('error', fail, { once: true })
      return
    }

    const script = document.createElement('script')
    script.id = id
    script.async = true
    script.src = src
    script.addEventListener(
      'load',
      () => {
        script.dataset.loaded = 'true'
        finalize()
      },
      { once: true },
    )
    script.addEventListener('error', fail, { once: true })
    document.body.appendChild(script)
  })

  pendingScriptLoads.set(key, promise)
  return promise
}
